import { blockImageTabs } from "../../includes/blocks/block-image-tabs/script";

if (document.querySelectorAll(".blockImageTabs__wrapper")) {
  blockImageTabs();
}

document.addEventListener("DOMContentLoaded", function () {
  //video
  document
    .querySelectorAll(".custom-video-wrapper")
    .forEach(function (wrapper) {
      const playBtn = wrapper.querySelector(".video-play-btn");
      if (!playBtn) return;

      const video = wrapper.querySelector("video");

      if (video) {
        wrapper.addEventListener("click", function () {
          if (video.paused) {
            video.play();
            playBtn.classList.add("hidden");
          } else {
            video.pause();
            playBtn.classList.remove("hidden");
          }
        });
        video.addEventListener("ended", function () {
          playBtn.classList.remove("hidden");
        });
        return;
      }

      // Embedy Gutenberga (YouTube / Vimeo)
      const iframe = wrapper.querySelector("iframe");
      if (!iframe) return;

      const src = iframe.src || "";
      const isYouTube = /youtube\.com|youtu\.be/.test(src);
      const isVimeo = /vimeo\.com/.test(src);

      if (!isYouTube && !isVimeo) return;

      if (isYouTube && !src.includes("enablejsapi=1")) {
        iframe.src = src + (src.includes("?") ? "&" : "?") + "enablejsapi=1";
      }
      if (isVimeo && !src.includes("api=1")) {
        iframe.src = src + (src.includes("?") ? "&" : "?") + "api=1";
      }

      let isPlaying = false;

      function sendCommand(msg, origin) {
        iframe.contentWindow.postMessage(JSON.stringify(msg), origin || "*");
      }

      function play() {
        if (isYouTube) {
          sendCommand({ event: "command", func: "unMute", args: [] });
          sendCommand({ event: "command", func: "playVideo", args: [] });
        } else {
          sendCommand({ method: "setVolume", value: 1 }, "https://player.vimeo.com");
          sendCommand({ method: "play" }, "https://player.vimeo.com");
        }
        playBtn.classList.add("hidden");
        isPlaying = true;
      }

      function pause() {
        if (isYouTube) {
          sendCommand({ event: "command", func: "pauseVideo", args: [] });
        } else {
          sendCommand({ method: "pause" }, "https://player.vimeo.com");
        }
        isPlaying = false;
      }

      // Subskrypcja eventów Vimeo – od razu i po każdym przeładowaniu
      if (isVimeo) {
        function subscribeVimeoEvents() {
          sendCommand({ method: "addEventListener", value: "finish" }, "https://player.vimeo.com");
          sendCommand({ method: "addEventListener", value: "play" }, "https://player.vimeo.com");
          sendCommand({ method: "addEventListener", value: "pause" }, "https://player.vimeo.com");
        }
        iframe.addEventListener("load", subscribeVimeoEvents);
        subscribeVimeoEvents();
      }

      wrapper.addEventListener("click", function () {
        isPlaying ? pause() : play();
      });

      // Mobile: tapnięcie w iframe (natywne kontrolki) — window traci focus
      window.addEventListener("blur", function () {
        if (document.activeElement === iframe) {
          playBtn.classList.add("hidden");
          isPlaying = true;
        }
      });

      window.addEventListener("message", function (e) {
        if (e.source !== iframe.contentWindow) return;
        try {
          const data = typeof e.data === "string" ? JSON.parse(e.data) : e.data;
          if (isYouTube && data.event === "infoDelivery" && data.info) {
            // playerState 1 = playing
            if (data.info.playerState === 1) {
              sendCommand({ event: "command", func: "unMute", args: [] });
              playBtn.classList.add("hidden");
              isPlaying = true;
            }
            // playerState 2 = paused
            if (data.info.playerState === 2) {
              isPlaying = false;
            }
            // playerState 0 = zakończone
            if (data.info.playerState === 0) {
              playBtn.classList.remove("hidden");
              isPlaying = false;
            }
          }
          // Vimeo: play
          if (isVimeo && data.event === "play") {
            sendCommand({ method: "setVolume", value: 1 }, "https://player.vimeo.com");
            playBtn.classList.add("hidden");
            isPlaying = true;
          }
          // Vimeo: pause
          if (isVimeo && data.event === "pause") {
            isPlaying = false;
          }
          // Vimeo: finish
          if (isVimeo && data.event === "finish") {
            playBtn.classList.remove("hidden");
            isPlaying = false;
          }
        } catch (_) {}
      });
    });

  //offer/plans
  const allPackageTabs = document.querySelectorAll(
    ".package-tabs > .kt-tabs-wrap > .kt-tabs-title-list > li"
  );

  allPackageTabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      // package index
      let packageIndex = null;
      if (tab.classList.contains("kt-title-item-1")) packageIndex = 1;
      if (tab.classList.contains("kt-title-item-2")) packageIndex = 2;
      if (tab.classList.contains("kt-title-item-3")) packageIndex = 3;
      if (!packageIndex) return;

      // tabs titles
      allPackageTabs.forEach((t) => {
        t.classList.remove("kt-tab-title-active");
        t.classList.add("kt-tab-title-inactive");
      });

      document
        .querySelectorAll(
          `.package-tabs > .kt-tabs-wrap > .kt-tabs-title-list > li.kt-title-item-${packageIndex}`
        )
        .forEach((t) => {
          t.classList.add("kt-tab-title-active");
          t.classList.remove("kt-tab-title-inactive");
        });

      //tabs content
      const allContentTabs = document.querySelectorAll(
        ".package-tabs .kt-tabs-content-wrap > .wp-block-kadence-tab"
      );

      allContentTabs.forEach((content) => {
        content.setAttribute("aria-hidden", "true");
        content.style.display = "none";
      });

      document
        .querySelectorAll(
          `.package-tabs .kt-tabs-content-wrap > .kt-inner-tab-${packageIndex}`
        )
        .forEach((content) => {
          content.setAttribute("aria-hidden", "false");
          content.style.display = "block";
        });
    });
  });
});
